module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/iMac-36fc3eb3e379c365c8f6234d8a94a2ba.svg";